import React from 'react';

import Link from 'buyside/components/presentation/Link/link';
import PencilIcon from 'buyside/svgs/pencil.svg';
import { whitePaperEditUrl } from 'buyside/util/urlHelper';

import styles from 'buyside/components/presentation/IdeaShowPage/AuthorActions/authorActionsStyles.scss';

const WhitePaperEditReportButton: React.FC<{ id: string }> = ({ id }) => {
  return (
    <div className={styles.actionsButton}>
      <Link to={whitePaperEditUrl(id)}>
        <PencilIcon className={styles.actionsIcon} />
        Edit Report
      </Link>
    </div>
  );
};
export default WhitePaperEditReportButton;
